<template lang="pug">
    div
        p There is no Manual… are you crazy?
        img(src="https://www.moma.org/interactives/exhibitions/2011/AccesstoTools/images/Understanding%20Whole%20Systems/Spaceship%20Earth.jpg")
</template>

<script>
    export default {
        name: "manual"
    }
</script>

<style scoped>

</style>